import React, {
  useLayoutEffect,
  useState,
  useCallback,
  useRef,
  useEffect,
} from "react";
import {
  StyleSheet,
  View,
  TextInput,
  TextInputProps,
  NativeSyntheticEvent,
  TextInputKeyPressEventData,
  ScrollView,
} from "react-native";
import { colors } from "src/assets";
import { Button } from "src/components";
import { useNavigation, useRoute } from "@react-navigation/native";
import { EventRegister } from "react-native-event-listeners";
import LocalText from "src/local";
import { RootStackScreenProps } from "src/navigation/types";

export type CustomTextEditNavigationParam = {
  title: string;
  text?: string;
  placeholder?: string;
  eventName: string;
  isMultiline?: boolean;
  textInputProps?: TextInputProps;
};

export const CustomTextEdit: React.FC = () => {
  const navigation =
    useNavigation<RootStackScreenProps<"CustomTextEdit">["navigation"]>();
  const route = useRoute<RootStackScreenProps<"CustomTextEdit">["route"]>();
  useLayoutEffect(() => {
    navigation.setOptions({ title: route.params.title });
  }, [navigation, route.params.title]);
  const textInputRef = useRef<TextInput>(null);
  const [text, setText] = useState<string>(route.params.text ?? "");
  useEffect(() => {
    textInputRef.current?.focus();
  }, [textInputRef]);

  const onChangeText = useCallback(
    (t: string) => {
      setText(route.params.isMultiline ? t : t.split("\n").join(""));
    },
    [route]
  );

  const onKeyPress = useCallback(
    (event: NativeSyntheticEvent<TextInputKeyPressEventData>) => {
      if (event.nativeEvent.key === "Enter" && !route.params.isMultiline) {
        textInputRef.current?.blur();
      }
    },
    [route, textInputRef]
  );

  return (
    <View style={styles.container}>
      <TextInput
        ref={textInputRef}
        style={styles.text}
        // placeholder={route.params.placeholder} // FIXME: color
        multiline={true}
        value={text}
        onChangeText={onChangeText}
        // onKeyPress={onKeyPress}
        returnKeyType={route.params.isMultiline ? "default" : "done"}
        scrollEnabled={true}
        {...route.params.textInputProps}
      />

      <View style={styles.actionContainer}>
        <Button
          containerStyle={styles.action}
          variant={"secondary"}
          title={LocalText.common.cancel}
          onPress={() => {
            navigation.goBack();
          }}
        />
        <Button
          containerStyle={styles.action}
          variant={"primary"}
          title={LocalText.common.done}
          onPress={() => {
            EventRegister.emit(route.params.eventName, text);
            navigation.goBack();
          }}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.white,
  },
  text: {
    flex: 1,
    margin: 8,
    outlineStyle: "none",
  },
  actionContainer: {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    paddingVertical: 16,
    paddingLeft: 16,
    paddingRight: 8,
    shadowColor: colors.black,
    shadowOffset: { width: 0, height: -2 },
    shadowOpacity: 0.1,
    backgroundColor: colors.white,
  },
  action: {
    flex: 1,
    marginRight: 8,
  },
  detail: {
    color: colors.chokuBlack,
  },
});
